import { render } from "./unified-login.vue?vue&type=template&id=0032acfb&ts=true"
import script from "./unified-login.vue?vue&type=script&lang=ts"
export * from "./unified-login.vue?vue&type=script&lang=ts"

import "./unified-login.vue?vue&type=style&index=0&id=0032acfb&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__